


import React, { useEffect } from 'react';

const Adx1BannerVideoDesk = ({ blockId, renderTo }) => {
  useEffect(() => {
    // Verifica si el objeto Ya está disponible antes de usarlo
    if (window.Ya) {
      window.Ya.Context.AdvManager.render({
        blockId: blockId,
        renderTo: renderTo,
        async: true,
      });
    } else {
      console.error('Adx1BannerVideo script not loaded');
    }
  }, [blockId, renderTo]);

  return <div id={renderTo}></div>;
};

export default Adx1BannerVideoDesk;